import Vuex from 'vuex'
import * as modules from './modules'
import createPersistedState from 'vuex-persistedstate'

const store = new Vuex.Store({
  plugins: [createPersistedState({
        storage: window.localStorage,
        reducer(state) {
          const persistedState = {...state};
          delete persistedState.documentStore; // documentStore模块不缓存
          return persistedState;
        }
      }
  )],
  modules: {
    ...modules
  }
});
export default store;
